import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
  /* Reset & Base Styles */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html,
  body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: var(--font-family-primary);
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-normal);
    color: var(--color-text-primary);
    background-color: var(--color-background);
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-tight);
    color: var(--color-text-primary);
  }

  h1 { font-size: var(--font-size-4xl); }
  h2 { font-size: var(--font-size-3xl); }
  h3 { font-size: var(--font-size-2xl); }
  h4 { font-size: var(--font-size-xl); }
  h5 { font-size: var(--font-size-lg); }
  h6 { font-size: var(--font-size-base); }

  p {
    margin: 0;
    font-family: var(--font-family-primary);
    line-height: var(--line-height-normal);
  }

  label {
    font-family: var(--font-family-primary);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-primary);
    line-height: var(--line-height-normal);
  }

  /* Form Elements */
  input,
  select,
  textarea,
  button {
    font-family: var(--font-family-primary);
    font-size: inherit;
  }

  /* Links */
  a {
    color: var(--color-primary-500);
    text-decoration: none;
    transition: color var(--transition-fast);
  }

  a:hover {
    color: var(--color-primary-700);
  }

  /* Scrollbar Styling (webkit browsers) */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--color-neutral-200);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--color-neutral-400);
    border-radius: var(--radius-sm);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-neutral-500);
  }

  /* React Datepicker Fix */
  .react-datepicker-wrapper {
    width: 100% !important;
  }

  /* Focus Visible (Accessibility) */
  *:focus-visible {
    outline: 2px solid var(--color-primary-500);
    outline-offset: 2px;
  }

  /* Selection */
  ::selection {
    background-color: var(--color-primary-100);
    color: var(--color-primary-900);
  }
`
